import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import { MainLayoutBase } from '@/layout/mainLayout/MainLayoutBase';
import { HeaderBase } from '@/layout/mainLayout/header';
import type { LookoRouteObject } from '@/router/LookoRouteObject';

// 업로드 설정
const 필수_설정_도우미_라우터 = {
  상품_입력_정보: {
    path: '/settings/assistant/item-input-field',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/상품_입력_정보_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 입력 정보 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  상품코드: {
    path: '/settings/assistant/product-code',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/상품코드_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품코드 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  상품명: {
    path: '/settings/assistant/item-title',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/상품명_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품명 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  이미지_설정: {
    path: '/settings/assistant/item-image',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/상품_이미지_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '이미지 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  디테일컷: {
    path: '/settings/assistant/detail-cut',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/디테일컷_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '디테일컷 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  치수: {
    path: '/settings/assistant/clothes-size',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/치수_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '치수 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  원산지: {
    path: '/settings/assistant/origin',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/원산지_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '원산지 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  소재: {
    path: '/settings/assistant/fabric',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/소재_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '소재 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  컨디션: {
    path: '/settings/assistant/condition',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/컨디션_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '컨디션 설정',
      hideSidebar: true,
    },
  } as LookoRouteObject,

  완료_화면: {
    path: '/settings/assistant/finished',
    async lazy() {
      const { default: Page } = await import('@/router/settings/assistant/완료_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '필수 설정 도우미 완료',
      hideSidebar: true,
    },
  } as LookoRouteObject,
};

export const 필수_설정_도우미_루트: RouteObject = {
  element: (
    <MainLayoutBase appBar={<HeaderBase />}>
      <Outlet />
    </MainLayoutBase>
  ),
  children: values(필수_설정_도우미_라우터),
};

export default 필수_설정_도우미_라우터;
